import React from 'react'
import PDFViewer from '../PDFViewer'

type Props = {
  filename: string
}

function CaseStudyPDF({filename}: Props) {
  return (
    <PDFViewer
      file={`https://bksps-live-public.s3.us-east-2.amazonaws.com/practice_exam_files/${filename}`}
      height="600px"
    />
  )
}

export default CaseStudyPDF
